export class Income {

    public totalEarnings:string = '';
    public retirementIncome:string = '';
    public severanceIncome:string = '';
    public otherIncome:string = '';

}
